var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10029 22.5842C3.96136 20.6858 3.96136 18.3145 5.10029 16.4163C5.47177 15.7972 6.10243 15.3784 6.81717 15.2763L10.605 14.7352C11.0949 14.6652 11.5318 14.3899 11.8063 13.9781L12.4029 13.0833C12.8753 12.3746 13.1116 12.0203 13.3743 11.7017C14.3011 10.5777 15.5131 9.72354 16.8834 9.22874C17.2717 9.08849 17.685 8.98521 18.5113 8.77862L19.5074 8.52957C20.0601 8.39141 20.3363 8.32234 20.5539 8.39003C20.7427 8.44881 20.9036 8.57447 21.0065 8.74342C21.1249 8.93802 21.1249 9.22285 21.1249 9.79249V29.208C21.1249 29.7776 21.1249 30.0624 21.0065 30.2569C20.9036 30.4259 20.7427 30.5515 20.5539 30.6104C20.3363 30.6781 20.0601 30.6089 19.5074 30.4708L18.5113 30.2218C17.685 30.0151 17.2717 29.9119 16.8834 29.7717C15.5131 29.2769 14.3011 28.4228 13.3743 27.2988C13.1116 26.9801 12.8753 26.6259 12.4029 25.917L11.8063 25.0223C11.5318 24.6105 11.0949 24.3353 10.605 24.2652L6.81717 23.7241C6.10243 23.6221 5.47177 23.2033 5.10029 22.5842Z",
    fill: "#F6FBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3834 12.8932C24.8593 12.4172 25.6311 12.4172 26.107 12.8932C27.8502 14.6365 28.8339 16.9981 28.8437 19.4634C28.8533 21.9288 27.8883 24.2981 26.1589 26.055C25.6866 26.5347 24.9149 26.5407 24.4352 26.0685C23.9557 25.5964 23.9495 24.8247 24.4217 24.345C25.7 23.0465 26.4133 21.2952 26.4062 19.4729C26.399 17.6508 25.6718 15.9053 24.3834 14.6167C23.9074 14.1408 23.9074 13.3691 24.3834 12.8932Z",
    fill: "#F6FBFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/Unmute.eb0c0aabed70025bc30742755681f646.svg";
export { ForwardRef as ReactComponent };